import InputBase, {
  InputBaseComponentProps,
  InputBaseProps,
} from '@material-ui/core/InputBase';

const InputDuration = (props: InputBaseProps) => {
  const { onChange } = props;
  return (
    <InputBase
      {...props}
      onChange={event => {
        const pattern = /^(\d+)?(:?)(\d+)?$/;
        const { value } = event.target;

        if (pattern.test(value) && onChange) onChange(event);
      }}
    />
  );
};

export default InputDuration as React.ElementType<InputBaseComponentProps>;
